import React from 'react';

const ChecklistProgress = ({ checklist }) => {
  const numItems = checklist.checklistItems.length;
  const numCompletedItems = checklist.checklistItems.filter(item => item.complete).length;
  const progressText = `${numCompletedItems} of ${numItems}`;
  const progressPercent = `${Math.floor((numCompletedItems / numItems) * 100)}%`;

  return (
    <div>
      <div className="referral-checklist-progress">
        <div className="progress-label">
          <span>{progressText}</span>
        </div>
        <div className="progress-bar-container">
          <div style={{ overflow: 'hidden' }} className="progress">
            <div className="bar" style={{ width: progressPercent }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChecklistProgress;
